<template>
  <div
    v-tooltip="{ text: chip.TooltipText, show: chip.TooltipText.length, theme: { placement: 'top' } }"
    class="flex relative px-2 max-w-[300px] h-8 m-0.5 border shadow cursor-pointer bg-default"
    :style="chipStyle"
    :class="{
      'border-blue-50 border-2': active && chip.CatalogArticleId === active.CatalogArticleId,
      'rounded': chip.Type === 'rect',
      'rounded-full': chip.Type === 'circle',
    }"
    @click="onClick"
  >
    <div v-if="chip.Status !== 1" class="w-full h-8 inactive-chip" />
    <div
      class="m-auto overflow-hidden whitespace-nowrap text-ellipsis"
      :class="{ 'pattern-text-highlight': chip.ColorType === 'Pattern' }"
    >
      {{ chip.ColorCode }} {{ (chip.Text.length) ? '-' : '' }} {{ chip.Text }}
    </div>
  </div>
</template>

<script setup lang="ts">
import tinycolor from 'tinycolor2'
import type { CSSProperties } from 'vue'
import { computed } from 'vue'
import utils from '@/services/utils'
import { useUserStore } from '@/store/userData'
import appConfig from '@/services/appConfig'

export interface IColorCodeChip {
  Type: 'rect' | 'circle'
  CatalogCode: number
  ArticleId: number
  ArticleNumber: string
  CatalogArticleId: string
  SourceArticleId?: number | null
  IsRequest: boolean
  ColorCode: string
  Status: number
  HexCode: string | null
  ColorType: string | null
  ColorAssetId: string | null
  Text: string | ''
  TooltipText: string | ''
}

const props = defineProps<{
  chip: IColorCodeChip
  active?: IColorCodeChip
}>()

const emit = defineEmits<{
  (e: 'click', data: IColorCodeChip): void
}>()

const userStore = useUserStore()

const chipStyle = computed<CSSProperties>(() => {
  if (props.chip.ColorType === 'Pattern') {
    return {
      backgroundImage: `url(${getPatternImage(props.chip)})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      color: 'black',
    }
  }

  if (utils.isValidStringValue(props.chip.HexCode)) {
    return {
      backgroundColor: props.chip.HexCode || undefined,
      color: tinycolor(props.chip.HexCode!).getBrightness() < 128 ? 'white' : 'black',
    }
  }

  return {}
})

function getPatternImage(chip: any) {
  if (
    !chip.ColorAssetId
    || !userStore.activeCatalog
    || !userStore.activeCatalog.DuneContext
    || !userStore.activeCatalog.ContextKey
  ) {
    return ''
  }

  const params = new URLSearchParams()
  params.set('Context', userStore.activeCatalog.DuneContext)
  params.set('ContextKey', userStore.activeCatalog.ContextKey)
  params.set('w', '64')
  params.set('trim', 'false')
  params.set('f', 'webp')

  return `${appConfig.AssetsUrl}/assets/content/${chip.ColorAssetId.toUpperCase()}?${params.toString()}`
}

function onClick() {
  emit('click', props.chip)
}
</script>

<style scoped>
.inactive-chip {
  position: absolute;
  border-top: 2px solid red;
  top: 50%;
  left: 0;
  /* transform-origin: 0% 0%;
    transform: rotate(45deg);*/
}
.pattern-text-highlight {
  text-shadow:
    1px 1px 2px rgba(255, 255, 255, 0.8),
   -1px -1px 2px rgba(255, 255, 255, 0.8);
  font-weight: 600;
}
</style>
